import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { PublicState as PublicStateList } from 'utils/constant';
import DefaultLayout from 'components/layout/DefaultLayout';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import CapsuleButton from 'components/button/CapsuleButton';
import MainTable from 'components/table/MainTable';
import DefaultButton from 'components/button/DefaultButton';
import TableToolbar from 'components/table/TableToolbar';
import TextButton from 'components/button/TextButton';
import PublicState from 'components/etc/PublicState';
import { attendanceApi } from 'apis/operation/attendanceApis';
import UtcTimer from 'components/etc/UtcTimer';
import { IAttendanceProps } from 'utils/types/operationTypes';
import { useTranslation } from 'react-i18next';
/**
 * * 운영 관리 - 출석 보상 관리 목록
 */

const AttendanceListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const [attendanceData, setAttendanceData] = useState<IAttendanceProps[]>();
  const publicState = PublicStateList();

  const handleLink = (record) => () => {
    navigate(`/attendance/${record.attendance_id}`);
  };

  const handleDelete = (record) => async () => {
    const res = await attendanceApi.delete(record.attendance_id);
    if (res !== false) {
      message.success(t('attendance.alert.deleteSuccess'), 1);
      fetchData();
    }
  };

  const fetchData = async () => {
    const res = await attendanceApi.read();
    if (res !== false) {
      setAttendanceData(res);
    }
  };
  const ColumnOrigin = [
    {
      title: t('attendance.table.name'),
      dataIndex: 'name',
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('attendance.table.kind'),
      dataIndex: 'kind',
      sorter: (a, b) => a.kind - b.kind,
      render: (t, r) => <>{r.kind === -1 ? '연속 출석' : `${r.kind}일`}</>,
    },
    {
      title: t('attendance.table.fromDate'),
      dataIndex: 'from_date',
      render: (t, r, i) => (
        <>
          {r.from_date}
          <UtcTimer startDate={r.from_date} />
        </>
      ),
    },
    {
      title: t('attendance.table.toDate'),
      dataIndex: 'to_date',
      render: (t, r, i) => (
        <>
          {r.to_date}
          <UtcTimer endDate={r.to_date} />
        </>
      ),
    },
    {
      title: t('attendance.table.isPublic'),
      dataIndex: 'is_public',
      render: (text) => <PublicState value={text} />,
      filters: publicState,
      onFilter: (value, record) => record?.is_public === value,
      sorter: (a, b) => a.is_public - b.is_public,
    },
    {
      title: t('attendance.table.move'),
      dataIndex: 'move',
      render: (text, record, index) => (
        <div>
          <CapsuleButton onClick={handleLink(record)}>
            {t('attendance.table.edit')}
          </CapsuleButton>
          <DeletePopConfirm
            title={t('attendance.alert.deleteConfirm')}
            onConfirm={handleDelete(record)}
            disabled={JSON.parse(cookies.managementAuth)}
          />
        </div>
      ),
    },
  ];
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);

  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <div></div>
          <DefaultButton
            disabled={JSON.parse(cookies.managementAuth)}
            onClick={handleLink({ attendance_id: 0 })}
          >
            {t('attendance.header.addButton')}
          </DefaultButton>
        </TableToolbar>
        <MainTable columns={ColumnOrigin} dataSource={attendanceData} />
      </DefaultLayout>
    </>
  );
};

export default AttendanceListPage;
